const goals = {
  INTENSITY: 1,
  PREHENSION: 2,
  PHYSIQUE: 3,
  TECHNIQUE: 4,
  DEPLACEMENT: 5,
};

export default goals;
